module.exports = __webpack_public_path__ + "static/img/third2_1_2_active.07b565b2.jpg";